export default {
  nome: {
    value: null,
    maxlength: '200',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/subject/addsubject-form.js